export default __webpack_public_path__ + "static/media/coordinate-tracker.8e5747ad.png";